import { Route, Redirect } from 'react-router-dom';
import {VisitApplication, VisitorApplicationExtends, VisitorApplicationExtendsForSurveyInfo} from "../user/visit/application";
import VisitHistory from "../user/visit/history";
import Notice from "../user/visit/notice";
import Faq from "../user/visit/faq";
import {UserTemplate1} from "./template1";
import React, {useEffect, useState} from "react";
import Api from "../../interface/api/site";

export default function UserRouter(props) {

    const { match } = props;

    return (
        <UserTemplate1 className={props.location.pathname==='/visit' ? 'user nv_wrap' : 'user nv_wrap sub'}>
            <Route exact path={"/visit/application/long"} component={VisitApplication} />
            <Route exact path={"/visit/application"} component={VisitApplication} />
            <Route exact path={"/visit/history/re-mind/:visitorInfoSeq"} component={VisitorApplicationExtendsForSurveyInfo} />
            <Route exact path={"/visit/history/:visitorInfoSeq"} component={VisitorApplicationExtends} />
            <Route exact path={"/visit/history"} component={VisitHistory} />
            <Route exact path={"/visit/notice"} component={Notice} />
            <Route exact path={"/visit/faq"} component={Faq} />
            <Route exact path="/visit" component={UserRoot} />
        </UserTemplate1>
    )
}

function UserRoot() {
    const [ stepModal, setStepModal ] = useState(false);
    return (
        <>
            <div className="nv_main_banner">
                <div className="main_slider">
                    {
                        JSON.parse(localStorage.getItem('siteInfo')).name==='솔브레인에스엘디'
                            ? <div><img src="/resource/user/images/SLD_display2.jpg" alt="" className="nv_img nv_select_img" /></div>
                            : <div><img src="/resource/user/images/main_01.jpg" alt="" className="nv_img nv_select_img" /></div>
                    }
                </div>
            </div>

            <div className="nv_contents">
                <ul className="nv_quick">
                    <li><a href="/visit/application">내방신청</a></li>
                    <li><a href="/visit/application?type=long">장기출입신청</a></li>
                    <li><a href="#" onClick={() => setStepModal(true)}>내방신청절차</a></li>
                </ul>
                <div className="nv_board">
                    <div className="nv_notice">
                        <h2>공지사항</h2>
                        <a href="/visit/notice" className="nv_more">더보기</a>
                        <p><a href="#a">방문 예약 시스템 이용 안내</a></p>
                    </div>
                    <div className="nv_faq">
                        <h2>FAQ</h2>
                        <a href="/visit/faq" className="nv_more">더보기</a>
                        <p><a href="#a">방문 예약 완료가 되었는지 확인하는 방법</a></p>
                    </div>
                </div>
            </div>
            {
                stepModal && <VisitApplicationStepInfo setStepModal={setStepModal}/>
            }
        </>
    )
}

function VisitApplicationStepInfo({setStepModal}) {
    return (
        <div className="modal edu_modal modal2 on">
            <div className="modal_con">
                <div className="edu_slide_box">
                    <div className="owl-carousel owl-theme" style={{display:"block"}}>
                        <div><img src="/resource/common/images/visit_application_step_info.png" alt="" className="nv_img"/></div>
                    </div>
                </div>
                <div className="nv_btn_area">

                    <button id="eduComplatebtn"
                             type="button"
                             className="nv_btn_blue modal_close"
                             onClick={() => setStepModal(false)}
                    >닫기</button>
                </div>
            </div>
        </div>
    )
}
